<template>
  <b-form-group
    label="Giriş Miktarı"
    :label-for="'entry_amount_' + itemKey"
  >
    <validation-provider
      #default="{ errors }"
      name="Giriş Miktarı"
      rules="required"
    >
      <b-input-group :append="dataItem[itemKey].units">
        <cleave
          :id="'entry_amount_' + itemKey"
          v-model="dataItem[itemKey].entry_amount"
          class="form-control"
          :raw="true"
          :options="options"
          placeholder="Giriniz"
        />
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import { BFormGroup, BInputGroup } from 'bootstrap-vue'
import { localize, ValidationProvider } from 'vee-validate'
import { required } from '@core/utils/validations/validations'
import Cleave from 'vue-cleave-component'

export default {
  name: 'EntryAmountCard',
  components: {
    ValidationProvider, BFormGroup, BInputGroup, Cleave,
  },
  props: {
    itemKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
      options: {
        numeral: true,
        numeralDecimalMark: ',',
        delimiter: '.',
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['stockLines/dataItem']
    },
    stockData() {
      return this.$store.getters['stocks/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
